import * as schema from "./generated/schema";
import { request } from "@/api";
type PayrollCategoriesPath = schema.paths["/api/payroll_categories"];
type PayrollCategoriesResponse =
  PayrollCategoriesPath["get"]["responses"]["200"]["content"]["application/json"];
export type PayrollCategory = PayrollCategoriesResponse["items"][number];

export const getPayrollCategories = async () => {
  return await request.get<PayrollCategoriesResponse>({
    url: "/api/payroll_categories",
  });
};
